import {Attribute} from './attribute.model';

export class Entity extends Attribute {
  value: string;
  valid: boolean;
  auxCode: string;
}
